export var BoilerAdapterType;
(function (BoilerAdapterType) {
    BoilerAdapterType[BoilerAdapterType["UNKNOWN"] = 0] = "UNKNOWN";
    BoilerAdapterType[BoilerAdapterType["EBUS"] = 1] = "EBUS";
    BoilerAdapterType[BoilerAdapterType["EBUS_EB"] = 2] = "EBUS_EB";
    BoilerAdapterType[BoilerAdapterType["EBUS_ARISTON"] = 3] = "EBUS_ARISTON";
    BoilerAdapterType[BoilerAdapterType["EBUS_ARISTON_EB"] = 4] = "EBUS_ARISTON_EB";
    BoilerAdapterType[BoilerAdapterType["OPENTHERM"] = 5] = "OPENTHERM";
    BoilerAdapterType[BoilerAdapterType["OPENTHERM_EB"] = 6] = "OPENTHERM_EB";
    BoilerAdapterType[BoilerAdapterType["NAVIEN"] = 7] = "NAVIEN";
    BoilerAdapterType[BoilerAdapterType["BSB"] = 8] = "BSB";
    BoilerAdapterType[BoilerAdapterType["UNIVERSAL"] = 9] = "UNIVERSAL";
    BoilerAdapterType[BoilerAdapterType["ARDERIA"] = 10] = "ARDERIA";
    BoilerAdapterType[BoilerAdapterType["RINNAI"] = 11] = "RINNAI";
    BoilerAdapterType[BoilerAdapterType["MODBUS"] = 12] = "MODBUS";
})(BoilerAdapterType || (BoilerAdapterType = {}));
const translationBoilerAdapterType = {
    [BoilerAdapterType.UNKNOWN]: 'Неизвестно',
    [BoilerAdapterType.EBUS]: 'E-Bus',
    [BoilerAdapterType.EBUS_EB]: 'E-Bus (EB)',
    [BoilerAdapterType.EBUS_ARISTON]: 'E-Bus (Ariston)',
    [BoilerAdapterType.EBUS_ARISTON_EB]: 'E-Bus (Ariston) (EB)',
    [BoilerAdapterType.OPENTHERM]: 'OpenTherm',
    [BoilerAdapterType.OPENTHERM_EB]: 'OpenTherm (EB)',
    [BoilerAdapterType.NAVIEN]: 'NavieN',
    [BoilerAdapterType.BSB]: 'BSB',
    [BoilerAdapterType.UNIVERSAL]: 'Universal',
    [BoilerAdapterType.ARDERIA]: 'Arderia',
    [BoilerAdapterType.RINNAI]: 'Rinnai',
    [BoilerAdapterType.MODBUS]: 'Modbus',
};
export function translateBoilerAdapterType(type) {
    return translationBoilerAdapterType[type] ?? `Неизвестный: ${type}`;
}
